import React from 'react';
import { BookOpen, Package, Star, Tractor } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Tractor className="w-5 h-5 text-[#d4af37]" data-id="element-273" />,
    text: '+200 recursos didácticos'
  }, {
    icon: <BookOpen className="w-5 h-5 text-[#d4af37]" data-id="element-274" />,
    text: '12 libros complementarios'
  }, {
    icon: <Package className="w-5 h-5 text-[#d4af37]" data-id="element-275" />,
    text: '3 tomos + 1 módulo + 4 bonos'
  }, {
    icon: <Star className="w-5 h-5 text-[#d4af37] fill-[#d4af37]" data-id="element-276" />,
    text: '4.9/5 calificación'
  }];
  return <div className="bg-[#122618] border-y border-[#2c4c3b] py-6" data-id="element-277">
      <div className="container mx-auto px-4" data-id="element-278">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-279">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-medium text-[#fdfbf7]" data-id="element-280">
              {stat.icon}
              <span data-id="element-281">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}